// Initial state for the Redux store
export default {
  app: {
    token: "",
    sessionToken: "",
    loggedIn: false,
    mainAppLoading: false,
    loading: false,
    role: false,
    error: false,
    success: false,
    userDetails: false,
    appBarName: "",
    leftMenu: false,
    layout: false,
    defaultTheme: false,
    appTheme: false,
    portalConfig: false,
    // Custom Auth Orchestration (Option B)
    authRefreshing: false,
    authError: null,
  },
  menu: {
    data: false,
  },
  onBoarding: {
    data: false,
    error: false,
    loading: false,
  },
  provideRegistration: {
    formMode: "Create",
    questionData: false,
    kycQuestionData: false,
    questionUpdate: false,
    Equipment: false,
    searchDetails: {
      searchDbaName: "",
      searchStatus: "",
      searchAgentId: "",
      apiType: "search",
      recordPerPage: 10,
      pageNo: 1,
      sortColumn: "Updated_date",
      sortOrder: "desc",
      statusExpression: "NOT_IN",
    },
    data: false,
    mcclist: false,
    accountTypeList: false,
    ownerShipTypeList: false,
    statusList: false,
    countryTypeList: false,
    pricingTemplete: false,
    providerList: false,
    search: false,
    providerDetailsById: false,
    statusUpdate: false,
    changeSingleStatus: false,
    providerActivityById: false,
    providerParameterData: false,
    saveProviderParameter: false,
    deleteIncropration: false,
    deleteAddress: false,
    deleteIdProof: false,
    provideruserListById: false,
    loading: false,
    error: false,
    agentList: false,
    notesList: false,
  },
  table: {
    loading: false,
    error: false,
    initialCall: false,
    agentList: false,
    merchantList: false,
    notesList: false,
  },
  forms: {
    master: false,
  },
  merchantInformation: {
    data: false,
    selectUser: false,
    success: false,
    emailState: false,
    forgetPassword: false,
    authTokenCheck: false,
    changePassword: false,
    entityId: false,
    updateUserDetails: false,
    activeMobileList: false,
    error: false,
    loading: false,
    deleteDocument: false,
    paymentDetailsData: false,
    paymentCheckoutData: false,
    paymentMakeDetails: false,
    uploadDocument: false,
    genrateOfferData: false,
    sendEmailOffer: false,
    createOffer: false,
    showUserDetailsViaMail: false,
    showUserInfoViaMail: false,
    EmailRegisterData: false,
    userDocumentList: false,
    addProposalData: false,
    setUpMonthlyPayment: false,
    completedPlanUserList: false,
    setUpMonthltFromOffer: false,
    genrateOfferLoading: false,
    defaultValueOffer: false,
    preposalDataIds: false,
    flowType: false,
    sentOTPData: false,
    verifyOTPData: false,
    userIdForgetPassword: false,
    emailData1: JSON.parse(localStorage.getItem("emailData1")) || false,
  },
  roles: {
    formMode: "init",
    data: false,
    roleList: false,
    userList: false,
    searchDetails: {
      Name: "",
      Current_Status: "All",
      pageNo: 1,
      recordPerPage: 10,
      sortColumn: "Updated_Date",
      sortOrder: "desc",
    },
    roleDetailsById: JSON.parse(localStorage.getItem("rolePermission"))?.roleTab || false,
    updateRolePermission: false,
    lookupMasterData: JSON.parse(localStorage.getItem("rolePermission"))?.lookupMasterData || false,
    profileTypeList: false,
    landingpageList: false,
    timeZoneList: false,
    updateRoleStatus: false,
    loading: false,
    roleTab: JSON.parse(localStorage.getItem("rolePermission"))?.roleTab || false,
    error: false,
    notesList: false,
  },
  users: {
    formMode: "init",
    data: false,
    searchDetails: {
      Name: "",
      Role: "",
      Current_Status: "All",
      searchAgentId: "",
      recordPerPage: 10,
      pageNo: 1,
      sortColumn: "FName",
      statusExpression: "IN",
      sortOrder: "asc",
    },
    userList: false,
    userDetailsById: false,
    profileImage: false,
    roleList: false,
    countryTypeList: false,
    profileTypeList: false,
    statusUpdate: false,
    passwordUpdate: false,
    loading: false,
    userProvider: false,
    timeZoneList: false,
    groupListData: false,
    error: false,
    agentList: false,
    merchantList: false,
    notesList: false,
  },
  dashboard: {
    data: false,
    success: false,
    recentContactData: false,
    error: false,
    loading: false,
    recentAcceptOffer: false,
    expireApplicationData: false,
    defaultData: false,
    cptDistributionData: false,
    badDebatesData: false,
  },
  payment: {
    data: false,
  },
  payout: {
    lastCalcDate: false,
    error: false,
    loading: false,
  },
  searchDataManager: {
    searchBusinessName: "",
    searchManagerUID: "",
    searchEmail: "",
    searchStatus: null,
    searchStatusValue: "",
    searchManagerName: "",
    searchManagerId: "",
    searchPlatform: "",
    searchManagerType: "",
  },
  searchDataMerchant: {
    searchBusinessName: "",
    searchDbaName: "",
    searchStatus: null,
    searchStatusValue: "",
    searchManagerName: "",
  },
  searchDataApiLogs: {
    searchApiType: "",
    searchApiTypeValue: "",
    searchModule: "",
    searchModuleValue: "",
    searchRequestDate: "",
    searchResponseDate: "",
    searchStatus: null,
    searchStatusValue: "",
  },
  searchDataErrorCodes: {
    searchErrorCode: "",
    searchType: "",
    searchDescription: "",
    searchUpdatedOn: "",
  },
  searchDataTransactionHistory: {
    searchTxnID: "",
    searchStartAmount: "",
    searchEndAmount: "",
    searchStartDate: "",
    searchEndDate: "",
    dateRange: false,
    amountRange: false,
  },
  transactionListPagination: {
    currentPage: 1,
    rowsPerPage: 5,
  },
  merchantListPagination: {
    currentPage: 1,
    rowsPerPage: 5,
  },
};
